module.exports = __webpack_public_path__ + "img/panda.7bd0fd46.png";